import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(advancedFormat);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

const formatTags = (tags) => tags.map(({ title }) => title).join(', ');
const formatCreator = (author) => author && author.name;
const formatCategory = (category) => category && category.title;
const formatPublishedWeek = (createdAt) => dayjs(createdAt).format('YYYYww');
const formatPublishedIsoWeek = (createdAt) => {
  const day = dayjs(createdAt);

  return `${day.format('YYYY')}${day.isoWeek().toString().padStart(2, '0')}`;
};
const formatPublishedMonth = (createdAt) => dayjs(createdAt).format('YYYYMM');
const formatPublishedHour = (createdAt) => dayjs(createdAt)
  .format('YYYYMMDDHH');
const formatPublished = (createdAt) => {
  try {
    return dayjs(createdAt).toISOString();
  } catch {
    return '';
  }
};
const formatFeatured = (featured) => (featured ? 1 : 0);
const countNumberOfWords = (body) => body
  .replace(/<[^>]*>/g, '').trim().split(/\s+/g).length;

const getDataLayerVariables = ({
  id,
  title,
  creator,
  category,
  tags,
  featured,
  createdAt,
  body,
}) => ({
  id,
  author: formatCreator(creator),
  category: formatCategory(category),
  featured: formatFeatured(featured),
  date_published_isoweek: formatPublishedIsoWeek(createdAt),
  date_published_month: formatPublishedMonth(createdAt),
  date_published_week: formatPublishedWeek(createdAt),
  date_published_hour: formatPublishedHour(createdAt),
  date_published: formatPublished(createdAt),
  tags: formatTags(tags),
  social_title: title,
  words: countNumberOfWords(body),
});

export default getDataLayerVariables;
